export default __webpack_public_path__ + "static/media/artes_facil.4e3e3cd8.png";